import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

export default new Router({
		mode: 'history',
		routes: [
				{
						path: '/',
						name: 'isPcOrPhone',
						component: resolve => require(['@/components/isPcOrPhone/isPcOrPhone'], resolve)
				},
				{
						path: '/login',
						name: 'login',
						component: resolve => require(['@/components/login/login'], resolve)
				},
				{
						path: '/index',
						name: 'index',
						component: resolve => require(['@/components/index'], resolve)
				},
				{
						path: '/dataChart',
						name: 'dataChart',
						component: resolve => require(['@/components/dataChart/dataChart'], resolve)
				},
				{
						path: '/message',
						name: 'message',
						component: resolve => require(['@/components/message/message'], resolve)
				},
				{
						path: '/personalIndex',
						name: 'personalIndex',
						component: resolve => require(['@/components/personalIndex/personalIndex'], resolve)
				},
				{
						path: '/articlesIndex',
						name: 'articlesIndex',
						component: resolve => require(['@/components/articlesIndex/articlesIndex'], resolve)
				},
				{
						path: '/caseIndex',
						name: 'caseIndex',
						component: resolve => require(['@/components/caseIndex/caseIndex'], resolve)
				},
				{
						path: '/caseOnlineFinance',
						name: 'caseOnlineFinance',
						component: resolve => require(['@/components/caseOnlineFinance/caseOnlineFinance'], resolve)
				},
				{
						path: '/personalBindMess',
						name: 'personalBindMess',
						component: resolve => require(['@/components/personalBindMess/personalBindMess'], resolve)
				}
		]
		
})



// WEBPACK FOOTER //
// ./src/router/index.js